// src/pages/EmployeeList.js
import React, { useState, useEffect } from "react";
import "./EmployeeList.css";
import apiClient from "../utils/apiClient"; // use global API client
import SessionHandler from "../components/SessionHandler"; // global session expiry modal

const EmployeeList = () => {
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [manager, setManager] = useState("");
  const [reportingHR, setReportingHR] = useState("");

  // ===== Fetch employees using global API client =====
useEffect(() => {
  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const data = await apiClient("/auth/allemployees/");
      if (!data) return;

      // 🔴 REMOVE ADMIN DEPARTMENT
      const nonAdminEmployees = data.filter(
        (emp) => emp.department?.toLowerCase() !== "admin"
      );

      const sorted = nonAdminEmployees.sort((a, b) =>
        a.department?.localeCompare(b.department)
      );

      setEmployees(sorted);

      // extract unique departments (admin already removed)
      const uniqueDepartments = [
        ...new Set(sorted.map((emp) => emp.department).filter(Boolean)),
      ];
      setDepartments(uniqueDepartments);

    } catch (err) {
      console.error("Error fetching employees:", err.message);
      setError(err.message || "Failed to fetch employees");
    } finally {
      setLoading(false);
    }
  };

  fetchEmployees();
}, []);

  // ===== Set HR & Manager dynamically =====
  const setHRAndManager = (department) => {
    switch (department) {
      case "MSSQL DBA":
      case "HR":
      case "MSBI":
        setReportingHR("Shweta Chopdekar");
        setManager("Ashish Shetty");
        break;
      case "Cloud Support":
      case "Devlopment":
      case "Project Management":
      case "DevOps":  
        setReportingHR("Samartha Tukan");
        setManager("Kishor Chavan");
        break;
      case "Help Desk":
      case "Production Support":
      case "Webinar":
      case "Other": 
        setReportingHR("Shweta Chopdekar");
        setManager("Abhishek Mailoorkar");
        break;
      default:
        setReportingHR("");
        setManager("");
    }
  };

  // ===== Department filter logic =====
  const handleDepartmentChange = (e) => {
    const dept = e.target.value;
    setSelectedDepartment(dept);

    if (dept === "") {
      setFilteredEmployees([]);
      setHRAndManager("");
    } else {
      const filtered = employees.filter((emp) => emp.department === dept);
      setFilteredEmployees(filtered);
      setHRAndManager(dept);
    }
  };

  return (
    <div className="employee-list">
      <h2>Employee List</h2>

      <div className="department-selection">
        <select
          id="department"
          value={selectedDepartment}
          onChange={handleDepartmentChange}
        >
          <option value="">-- Select Department --</option>
          {departments.map((dept, idx) => (
            <option key={idx} value={dept}>
              {dept}
            </option>
          ))}
        </select>
      </div>

      {loading && <div>Loading...</div>}
      {error && <div style={{ color: "red" }}>Error: {error}</div>}

      {!loading && !error && selectedDepartment && (reportingHR || manager) && (
        <div className="hr-manager-row">
          <div className="left">
            <strong>Reporting HR:</strong> {reportingHR}
          </div>
          <div className="right">
            <strong>Manager:</strong> {manager}
          </div>
        </div>
      )}

      {!loading &&
        !error &&
        selectedDepartment &&
        filteredEmployees.length > 0 && (
          <table className="employee-table">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Employee ID</th>
                <th>Name</th>
                <th>Department</th>
                <th>Contact</th>
              </tr>
            </thead>
            <tbody>
              {filteredEmployees.map((emp, index) => (
                <tr key={emp.id}>
                  <td>{index + 1}</td>
                  <td>{emp.employee_id}</td>
                  <td>{emp.name}</td>
                  <td>{emp.department}</td>
                  <td>{emp.phone || emp.contact_number}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

      {!loading &&
        !error &&
        selectedDepartment &&
        filteredEmployees.length === 0 && (
          <div>No employees found in this department.</div>
        )}

      {/* Global session expiry modal */}
      <SessionHandler />
    </div>
  );
};

export default EmployeeList;
